import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bhpe",
  "use": "icon-bhpe-usage",
  "viewBox": "0 0 15 14",
  "content": "<symbol xmlns=\"https://www.w3.org/2000/svg\" xmlns:xlink=\"https://www.w3.org/1999/xlink\" viewBox=\"0 0 15 14\" id=\"icon-bhpe\">\n<path fill-rule=\"evenodd\" fill=\"gray\" d=\"M7.831,0.402 C7.664,0.402 7.497,0.464 7.367,0.589 L0.953,6.707 C0.752,6.899 0.687,7.194 0.789,7.453 C0.892,7.711 1.141,7.881 1.417,7.881 L4.793,7.881 L2.092,13.320 C2.092,13.696 2.394,14.000 2.767,14.000 L12.895,14.000 C13.268,14.000 13.570,13.696 13.570,13.320 L10.869,7.881 L14.245,7.881 C14.522,7.881 14.770,7.711 14.872,7.453 C14.975,7.194 14.911,6.899 14.710,6.707 L8.295,0.589 C8.165,0.464 7.998,0.402 7.831,0.402 ZM3.111,6.521 L7.831,2.019 L12.551,6.521 L9.519,6.521 C9.146,6.521 8.844,6.826 8.844,7.201 L11.545,12.640 L4.117,12.640 L6.818,7.201 C6.818,6.826 6.516,6.521 6.143,6.521 L3.111,6.521 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/bhpe.svg
// module id = BE1V
// module chunks = 12